import React, { PureComponent } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import NoData from "../../../../../Dashboard/Charts/NoData/NoData";
import { numberWithCommas } from "../../../../../Dashboard/utils";

class QuotesOverTimeChart extends PureComponent {
    constructor(props) {
        super(props);

        this.chartComponent = React.createRef();
        this.state = {
            rerender: 0,
        };
    }

    componentDidMount() {
        // if (!this.props.isTWPage) {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current?.chart?.setSize(null, null);
                this.chartComponent.current?.chart?.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef?.current) {
            this.ro.observe(this.props.widgetContainerRef?.current);
        } else {
            this.setState({ rerender: this.state.rerender + 1 });
        }
        // }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.rerender) {
            if (this.props.widgetContainerRef?.current) {
                this.ro.observe(this.props.widgetContainerRef?.current);

                this.setState({ rerender: 0 });
            } else if (prevState.rerender !== this.state.rerender) {
                setTimeout(() => {
                    this.setState({ rerender: this.state.rerender + 1 });
                }, 100);
            }
        }
    }

    componentWillUnmount() {
        // if (!this.props.isTWPage) {
        this.ro.disconnect();
        // }
    }

    getOptions = () => {
        if (this.props.graph_type == "line") return this.getLineOptions();
        else return this.getBarOptions();
    };

    getLineOptions = () => {
        let x = this.props.data;
        const height = this.props.isTWPage ? "338px" : null;
        const legendAlign = this.props.isTWPage ? "right" : "center";
        let self = this;

        const pageViewConfig = {
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: null,
                    marker: {
                        enabled: true,
                        radius: 2,
                    },
                },
            },
            chart: {
                type: "spline",
                className: "skiptranslate",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                height,
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No Data.",
            },
            legend: {
                enabled: this.props.showLegend,
                alignColumns: false,
                align: legendAlign,
            },
            noData: {
                position: {
                    align: "center",
                },
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                // min: this.props.data?.avg_value,
                allowDecimals: false,
                plotLines: self.props.showAverage
                    ? [
                          {
                              color: "#8e95a4", // Color value
                              value: this.props.data?.avg_value, // Value of where the line will appear
                              width: 2, // Width of the line
                              dashStyle: "solid",
                              zIndex: 6,
                              label: {
                                  align: "right",
                                  text: `Average : ${numberWithCommas(this.props.data?.avg_value)}`,
                                  x: 0,
                                  style: {
                                      color: "#8e95a4",
                                      fontWeight: "bold",
                                  },
                              },
                          },
                      ]
                    : [],
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },
            tooltip: {
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${moment(this.x).startOf("day").format("LLLL")}</span>
                    <br/><span>${this.series.name}: <b>${numberWithCommas(this.y)}</b></span>`;
                },
            },
            series: [{ color: "purple", name: "Quotes", data: x?.data ? x.data : [] }],
            time: {
                useUTC: false,
            },
        };

        return pageViewConfig;
    };

    getBarOptions = () => {
        let x = this.props.data;
        const height = this.props.isTWPage ? "338px" : null;
        const legendAlign = this.props.isTWPage ? "right" : "center";
        let self = this;

        const pageViewColumnConfig = {
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: "normal",
                },
            },
            chart: {
                type: "column",
                height,
            },
            credits: {
                enabled: false,
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                // min: 0,
                allowDecimals: false,
                plotLines: self.props.showAverage
                    ? [
                          {
                              color: "#8e95a4", // Color value
                              value: this.props.data?.avg_value, // Value of where the line will appear
                              width: 2, // Width of the line
                              dashStyle: "solid",
                              zIndex: 6,
                              label: {
                                  align: "right",
                                  text: `Average : ${numberWithCommas(this.props.data?.avg_value)}`,
                                  x: 0,
                                  style: {
                                      color: "#8e95a4",
                                      fontWeight: "bold",
                                  },
                              },
                          },
                      ]
                    : [],
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },
            lang: {
                noData: "No Data.",
            },
            tooltip: {
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${moment(this.x).startOf("day").format("LLLL")}</span>
                    <br/> <span>${this.series.name}: <b>${numberWithCommas(this.y)}</b></span>`;
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                    paddingTop: "10px",
                    color: "#1f2e3d",
                },
                alignColumns: false,
                paddingTop: 18,
                align: legendAlign,
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#1f2e3d",
                    fontFamily: "'Roboto', sans-serif",
                },
                position: {
                    align: "center",
                },
            },
            series: [{ color: "purple", name: "Quotes", data: x?.data ? x.data : [] }],
            time: {
                useUTC: false,
            },
        };

        return pageViewColumnConfig;
    };

    render() {
        return (
            <>
                {!this.props.isNoData() && !this.props.error ? (
                    <>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOptions()}
                            ref={this.chartComponent}
                            containerProps={!this.props.isTWPage && { style: { width: "100%", height: "calc(100% - 20px)" } }}
                        />
                    </>
                ) : (
                    <NoData message={this.props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                )}
            </>
        );
    }
}

export default QuotesOverTimeChart;
